import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
// const CarImg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/16. 버스사업소개 버스3.b1412f4034c7f765d4d2.png`;
import CarImg from "../../assets/BusBusiness/버스사업소개 버스.png";
// const MapImg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/17. 버스사업 글로벌지도.43b474ed4fc68e8269af.png`;


import MapImgKor from "../../assets/BusBusiness/버스사업 글로벌지도_kor.png";
import MapImgEng from "../../assets/BusBusiness/버스사업 글로벌지도_eng.png";


const CarBusinessHistory = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"상용버스사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">버스사업</div>
                <div className="eng">Bus Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"156px"}>
            <S.NavItem>
              <Link to="/BusBusiness/OverseasBus">
                <div className="kor">해외 상용버스사업</div>
                <div className="eng">Overseas commercial bus business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">해외 상용버스사업</div>
                  <div className="eng">Overseas commercial bus business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/Factory">
                  <div className="kor">생산공장</div>
                  <div className="eng">production plant</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/BusBusinessHistory">
                  <div className="kor">버스사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"사업개요"} titleeng={"Business Briefs"} />
            <div className="page-text">
              <div className="kor">
                영안은 1995년 코스타리카의 마우코사를 인수하며, 버스 사업에 최초 진출 하였습니다. 
2003년 5월 대우자동차(주)에서 분리된 한국 대우버스(주)를 인수하였습니다.
이후 2003년 중국 계림 법인 인수, 2003년 코스타리카 법인 신규 설립, 2005년 베트남 법인 신규 설립,
2007년 카자흐스탄 합자법인 신규 설립, 2008년 파키스탄 합자법인 신규  설립, 2018년 미얀마 합자법인
신규 설립하여 버스사업 글로벌 경영 체계를 완성 시켰습니다.
2022년 7월 부터는 국내 공장 생산을 중단하고 법인 청산 절차를 진행하고 있습니다. 
현재는 오랜 노하우를 가진 글로벌 경영방식으로 해외 생산 공장 4곳, 판매법인 1곳 통한 버스사업을
진행 중입니다.
              </div>
              <div className="eng">
                YoungAn initially entered the bus industry in 1995 by acquiring Mauco in Costa Rica.
In May 2003, the company acquired Daewoo Bus Corp. Korea, which had been spun off from
Daewoo Motor Co., Ltd.
Subsequently, YoungAn established a comprehensive global management system for its bus
business by acquiring a corporate entity in Guilin, China in 2003, establishing new corporate
entities in Costa Rica in 2003 and Vietnam in 2005, and setting up new joint venture
corporations in Kazakhstan in 2007, Pakistan in 2008, and Myanmar in 2018.
Since July 2022, domestic plant production has been discontinued, and the liquidation
process for the domestic corporate entity is currently underway.
Presently, utilizing a global management approach backed by long-standing expertise,
the company continues to drive its bus business forward through 4 overseas production
plants and 1 sales corporation.
              </div>
            </div>
            <PageTitle titleko={"사업장 현황"} titleeng={"Business Status"} />

            <div className="page-text">
              <div className="kor">
                생산공장 4곳 (베트남 / 중국 계림 / 파키스탄 / 카자흐스탄)
                <br />
                판매법인 1곳 (코스타리카)
              </div>
              <div className="eng">
                Production facilities: 4 (Vietnam, China (Guilin), Pakistan, Kazakhstan
                
                <br />
                Sales corporation: 1 (Costa Rica)
              </div>
              <img src={CarImg} alt="" className="hat-img" />
            </div>

            <img
  src={MapImgKor}
  alt="버스사업 글로벌지도"
  className="fullsize-map map-kor"
/>

<img
  src={MapImgEng}
  alt="Bus business global map"
  className="fullsize-map map-eng"
/>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default CarBusinessHistory;
